var map = {
	".": "Tl8j",
	"./": "Tl8j",
	"./01_balance": "qHKX",
	"./01_balance.json": "qHKX",
	"./02_order": "tdP1",
	"./02_order.json": "tdP1",
	"./03_setting": "PEUY",
	"./03_setting.json": "PEUY",
	"./index": "Tl8j",
	"./index.js": "Tl8j"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vOn1";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/account ^.*$
// module id = vOn1
// module chunks = 3